import {Box} from "@mui/material";
import React from "react";

interface Props {
    children: React.ReactNode
}

function SurveySidebarPanel({children}: Props) {
    return (
        <Box sx={{height: '100%', minHeight: 0, overflowY: 'auto', px: 2, pt: 0.5, pb: 1.5}}>
            {children}
        </Box>
    );
}

export default SurveySidebarPanel;
